/**
 * Forwarding refs for a polymorphic React component in TypeScript
 * How to properly type polymorphic React components using forwardRef in TypeScript
 *
 *  Source:
 *  https://www.benmvp.com/blog/forwarding-refs-polymorphic-react-component-typescript/
 */

export const polymorphicAsProp = as => ({
  [typeof as === 'string' ? 'as' : 'forwardedAs']: as
});